import { LigneFinancement } from './ligneFinancement';

export class LigneFinancementMarche {
         id: number;
         code: string;
         montant: number;
         libelle: string;
  ligneFinancementId: number;
       }